import '../../../styles/pages.css'

import React, { useEffect, useState } from 'react'

import { Button, capitalize } from '@mui/material'
import RequestDialog from '../../dialogs/RequestDialog'
import { ILMSDistrictInfo } from 'infrastructure/api'
import { makeKiddomPostRequest } from 'infrastructure/api'
import { updateLMSSettings } from 'shared/api/mutations'

const LMSSync = ({
  districtLMSInfo,
}: {
  districtLMSInfo: ILMSDistrictInfo
}) => {
  const [open, setOpen] = useState(false)
  const [error, setError] = useState('')
  const [dailySyncEnabled, setDailySyncEnabled] = useState(
    districtLMSInfo.dailysyncenabled,
  )
  const [disableToggle, setDisableToggle] = useState(false)
  const title = `Are you sure you want to perform an LMS sync?`
  const content = [
    {
      key: `LMS Type`,
      value: districtLMSInfo.lmstype,
    },
    {
      key: `District ID`,
      value: String(districtLMSInfo.districtid),
    },
  ]

  useEffect(() => {
    if (!districtLMSInfo.dailysyncenabled && !districtLMSInfo.refreshtoken) {
      setDisableToggle(true)
    }
  }, [districtLMSInfo])

  const lsmSync = async () => {
    const districtID = districtLMSInfo.districtid
    try {
      setError('')
      await makeKiddomPostRequest({
        kiddomPath: `/v1/sis/ingestion/lms/sync?district_id=${districtID}`,
        requestBody: {},
      })
    } catch {
      setError('Error triggering LMS sync for the district')
    }
  }

  const ToggleDailySync = async () => {
    try {
      const resp = await updateLMSSettings(
        districtLMSInfo.integrationid,
        !dailySyncEnabled,
      )
      if (resp.errors) {
        setError('Error encountered' + resp.errors[0])
      } else {
        setDailySyncEnabled(!dailySyncEnabled)
      }
    } catch {
      setError('Error setting district LMS daily sync')
    }

    if (!dailySyncEnabled && !districtLMSInfo.refreshtoken) {
      setDisableToggle(true)
    }
  }

  return (
    <>
      <div className="section-buttons">
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => setOpen(true)}
        >
          {`Trigger LMS Sync`}
        </Button>
        {error && <p className="error">{error}</p>}
        <RequestDialog
          open={open}
          title={title}
          content={content}
          submitRequest={lsmSync}
          waitingTime={2000}
          onClose={() => setOpen(false)}
        />
      </div>
      <p>
        Daily LMS Sync:
        <span className={dailySyncEnabled ? 'sync-enable' : 'sync-disable'}>
          {` ${capitalize(String(dailySyncEnabled))} `}
        </span>
        <span className="section-buttons">
          <Button
            variant="outlined"
            color="secondary"
            onClick={ToggleDailySync}
            size="small"
            disabled={disableToggle}
          >
            Toggle
          </Button>
        </span>
      </p>
    </>
  )
}

export default LMSSync
